<template>
    <v-simple-table class="table-scrollable">
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Rule</th>
                    <th class="text-left">Matching Items</th>
                    <th class="text-left">Logs</th>
                    <th class="text-left">Result</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td colspan="4" class="text-center">
                        <v-progress-linear
                            indeterminate
                            color="primary"
                            class="mb-5">
                        </v-progress-linear>
                    </td>
                </tr>
                <tr v-for="(log, index) in logs" :key="index" class="align-top">
                    <td style="width: 15%" class="pt-2 pb-2">
                        <div>{{ log.rule + getMethodName(log.packingMethod) }}</div>
                        <div v-if="log.target">Target items: {{ log.target }} items</div>
                    </td>
                    <td style="width: 25%" class="pt-2 pb-2">
                        <ul v-if="log.items.length > 0">
                            <li v-for="(item, itemIndex) in log.items" :key="itemIndex">
                                {{ item }}
                            </li>
                        </ul>
                        <span v-else>No matching items</span>
                    </td>
                    <td style="width: 30%" class="pt-2 pb-2">

                        <ul v-if="log.logs.length > 0">
                            <li v-for="(pmLog, index) in log.logs" :key="index">
                                {{ pmLog }}
                            </li>
                        </ul>
                    </td>
                    <td style="width: 30%">
                        <expand-data :data="log.result" text="Result"></expand-data>
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import { integer } from 'vuelidate/lib/validators';
import ExpandData from '@/js/components/logs/components/ExpandData';
import { PACKING_METHODS } from '@/js/constants/packing-rules';
export default {
    components: {
        ExpandData
    },
    props: {
        recordId: {
            type: integer,
            required: false
        },
        integrationId: {
            type: integer,
            required: false
        },
        type: {
            type: String,
            required: false
        },
        testLogs: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            loading: true,
            logs: []
        }
    },

    mounted() {

        if(this.testLogs !== undefined) {
            this.loading = false;
            this.logs = this.testLogs;
        } else {
            this.getLogs(this.recordId);
        }
    },

    methods: {
        getLogs(recordId) {

            this.loading = true;

            this.$http
                .get(`api/item-packing/${this.integrationId}/${this.type}/logs/${recordId}`)
                .then(({ data }) => {
                    if(data.data) {
                        this.logs = Object.values(data.data).sort((a, b) => a.order - b.order);
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getMethodName(method) {
            const methodName = PACKING_METHODS.find((pm) => pm.value === method)?.text || '';
            return methodName ? ` (${methodName})` : '';
        }
    },
}
</script>